module.exports = __webpack_public_path__ + "static/media/samsung.9b7e2cf6.png";